import { FaqNode, OpenTicketsQueryParamsType } from '../../../screens/help-center/utils';
import { API_URL } from '../../../utils/config';
import {
  POP_FROM_HISTORY,
  SET_ACTIVE_CHAT_WEB_WIDGET,
  SET_CONFIGURATION_DATA,
  SET_CURRENT_HELP_CENTRE_TICKETS,
  SET_CURRENT_LEVEL_ITEMS,
  SET_HC_LEVEL_HISTORY,
  SET_HELP_CENTER_LABELS,
  SET_HELP_CENTER_SELECTED_TRANSACTION,
  RAISE_NEW_ENQUIRY,
  OPEN_EXISTING_CONVERSATION,
  RETURN_FROM_RAISE_ENQUIRY,
  SET_IS_REVAMP_API_CALLED,
  HELP_CENTER_UI_LOADING,
  RESET_HELP_CENTER_LEVELS,
  TOGGLE_NEW_TRANSACTION_CHAT,
  SET_ACTIVE_CHAT_INFO,
  SET_PUBLIC_PAGE_LEVEL_VALUE,
  TOGGLE_IS_NAVIGATED_FROM_DEEPLINK
} from '../../action-contants';
import { handleError } from '../common-message/message-action';
import { makeApiCall } from '../common/common-action';

const setCurrentLevelItemsAction = (items: any) => {
  return {
    type: SET_CURRENT_LEVEL_ITEMS,
    data: items
  };
};

export const setCurrentLevelItems = (item: FaqNode | { data: any; level: number }) => {
  return (dispatch: (data: any) => void): any => {
    dispatch(setCurrentLevelItemsAction(item));
  };
};

export const setConfigurationdata = (payload: any): any => {
  return {
    type: SET_CONFIGURATION_DATA,
    data: payload
  };
};

const pushToHistoryAction = (item: FaqNode | { data: any; level: number }) => {
  return {
    type: SET_HC_LEVEL_HISTORY,
    data: item
  };
};

const popFromHistoryAction = (data: FaqNode[]) => {
  return {
    type: POP_FROM_HISTORY,
    data
  };
};

export const pushToHCHistory = (item: FaqNode | { data: any; level: number }) => {
  return (dispatch: (data: any) => void): any => {
    dispatch(pushToHistoryAction(item));
  };
};

export const popFromCHistory = (item: FaqNode[]) => {
  return (dispatch: (data: any) => void): any => {
    dispatch(popFromHistoryAction(item));
  };
};

const setIsRevampApiCalledAction = (flag: boolean) => {
  return {
    type: SET_IS_REVAMP_API_CALLED,
    data: flag
  };
};

export const toggleIsRevampApiCalled = (flag: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(setIsRevampApiCalledAction(flag));
  };
};

export const setIsUILoadingAction = (flag: boolean) => {
  return {
    type: HELP_CENTER_UI_LOADING,
    data: flag
  };
};

const setIsNewTransactionChatCreatedAction = (flag: boolean) => {
  return {
    type: TOGGLE_NEW_TRANSACTION_CHAT,
    data: flag
  };
};

const setActiveChatInfoAction = (data: Record<string, any>) => {
  return {
    type: SET_ACTIVE_CHAT_INFO,
    data
  };
};
export const setActiveChatInfo = (ticketData: Record<string, any>) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(setActiveChatInfoAction(ticketData));
  };
};

export const toggleIsNewTransactionChatCreated = (flag: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(setIsNewTransactionChatCreatedAction(flag));
  };
};

const setHelpCenterLabelsAction = (data: Record<string, any>) => {
  return {
    type: SET_HELP_CENTER_LABELS,
    data
  };
};

const setHelpCenterSelectedTransactionAction = (data: Record<string, any>) => {
  return {
    type: SET_HELP_CENTER_SELECTED_TRANSACTION,
    data
  };
};

const newTicketAction = (data: boolean) => {
  return {
    type: RAISE_NEW_ENQUIRY,
    data
  };
};

const enquiryInitiatedBackNavAction = (data: boolean) => {
  return {
    type: RETURN_FROM_RAISE_ENQUIRY,
    data
  };
};

const setCurrentTicketsAction = (data: boolean) => {
  return {
    type: SET_CURRENT_HELP_CENTRE_TICKETS,
    data
  };
};

const openExistingConservation = (data: boolean) => {
  return {
    type: OPEN_EXISTING_CONVERSATION,
    data
  };
};

export const setHelpCenterLabels = (labels: Record<string, string>) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(setHelpCenterLabelsAction(labels));
  };
};

export const setHelpCenterSelectedTransaction = (data: Record<string, any>) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(setHelpCenterSelectedTransactionAction(data));
  };
};

export const raiseNewTicket = (data: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(newTicketAction(data));
  };
};

export const enquiryInitiatedBackNav = (data: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(enquiryInitiatedBackNavAction(data));
  };
};

export const setCurrentHelpCentreTickets = (data: any, newTicket?: any) => {
  const updatedTickets = [newTicket, ...data]; // Add newTicket to the existing array
  return (dispatch: (data: any) => void): void => {
    dispatch(setCurrentTicketsAction(newTicket ? updatedTickets : data));
  };
};

const setPublicPageLevelValueAction = (data: string) => {
  return {
    type: SET_PUBLIC_PAGE_LEVEL_VALUE,
    data
  };
};

export const setPublicPageLevelValue = (data: string) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(setPublicPageLevelValueAction(data));
  };
};

export const setOpenConversationFlag = (data: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(openExistingConservation(data));
  };
};
export function getTicketListFromZenDesk(params: OpenTicketsQueryParamsType | null = null) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const result = await makeApiCall({
        method: 'get',
        url: `${API_URL}/help-center/tickets`,
        params: params,
        withCredentials: true
      });
      return result;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function createZendeskTicket(data: any) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    const {
      subject,
      description,
      attachments,
      groupId,
      level_1,
      transactionNo,
      deviceType,
      priority,
      remittanceTags
    } = data;
    try {
      const formData = new FormData();
      formData.append('description', description);
      formData.append('subject', subject);
      formData.append('groupId', groupId);
      if (level_1) formData.append('level_1', level_1);
      formData.append('deviceType', deviceType);
      formData.append('priority', priority);
      if (remittanceTags) formData.append('remittanceTags', remittanceTags);
      if (transactionNo) formData.append('transactionNo', transactionNo);
      if (attachments) {
        const files = [...attachments];
        files?.forEach((item) => formData.append('attachments', item, item?.name));
      }

      const result = await makeApiCall({
        method: 'post',
        url: `${API_URL}/help-center/ticket`,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
        withCredentials: true
      });
      return result?.data;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function addNotesToZenDeskTicket(ticketId: string, body: string, attachment: FileList) {
  return async (dispatch: (data: any) => void) => {
    try {
      const formData = new FormData();
      formData.append('ticketId', ticketId);
      if (body) formData.append('body', body);
      if (attachment) {
        const files = [...attachment];
        files?.forEach((item) => formData.append('attachments', item, item.name));
      }
      const result = await makeApiCall({
        method: 'post',
        url: `${API_URL}/help-center/note`,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
        withCredentials: true
      });
      return result?.data;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
export function getZenDeskTicketConversationHistory(ticketId: string) {
  return async (dispatch: (data: any) => void) => {
    try {
      const result = await makeApiCall({
        method: 'get',
        url: `${API_URL}/help-center/conversations`,
        params: {
          ticketId
        },
        withCredentials: true
      });
      return result?.data;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
export const setActiveChatAction = (data: boolean) => {
  return {
    type: SET_ACTIVE_CHAT_WEB_WIDGET,
    data
  };
};

export const setZenDeskActiveChat = (isChatActive: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(setActiveChatAction(isChatActive));
  };
};

export const getZendeskToken = () => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/help-center/messaging-token`,
        withCredentials: true
      });
      return { token: response.data?.data?.token, success: true };
    } catch (exception) {
      dispatch(handleError(exception));
      return { success: false };
    }
  };
};

export function getAttachmentFilefromConversation(conversationData: any) {
  return async (dispatch: (data: any) => void) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${conversationData?.contentUrl}`,
        responseType: 'blob'
      });

      if (response?.status === 200) {
        const blob = new Blob([response.data]);
        const link = document.createElement('a');
        const URL = window.URL || window.webkitURL;
        link.href = URL.createObjectURL(blob);
        link.download = conversationData?.fileName;
        document.body.appendChild(link);
        link.click();
        return true;
      }
      return false;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export const resetHelpCenterLevels = (data: boolean) => {
  return {
    type: RESET_HELP_CENTER_LEVELS,
    data
  };
};

export function createZendeskTicketforPublicPage(data: any) {
  return async (dispatch: (data: any) => void) => {
    const payload = new FormData();
    Object.keys(data).forEach((key) => payload.append(key, data[key]));
    try {
      return await makeApiCall({
        url: `${API_URL}/public/help-center/ticket`,
        method: 'post',
        withCredentials: true,
        data: payload
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(`create ticket error ${error}`);
      dispatch(handleError(error));
      return false;
    }
  };
}

export const toggleIsNavigatedFromDeepLinkAction = (flag: boolean) => {
  return {
    type: TOGGLE_IS_NAVIGATED_FROM_DEEPLINK,
    data: flag
  };
};

export const toggleIsNavigatedFromDeepLink = (flag: boolean) => {
  return (dispatch: (data: any) => void): void => {
    dispatch(toggleIsNavigatedFromDeepLinkAction(flag));
  };
};
